// extracted by mini-css-extract-plugin
export default {"-large":"gRiZar0AUvwsGM_Q0RdA","infoIcon":"bYYCSlLRfWEtKRaseBsU","delete":"YeR9f4ob_2o2QxxOfeX3"};